var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCtLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 32,
    viewBox: "0 0 49 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9856 29.6274C48.9856 30.9352 47.9247 31.9961 46.6169 31.9961C45.3092 31.9961 44.2483 30.9352 44.2483 29.6274C44.2483 28.3197 45.3092 27.2588 46.6169 27.2588C47.9209 27.2588 48.9856 28.3197 48.9856 29.6274Z",
    fill: "#03CDEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8013 3.15949C8.81881 3.15949 3.15949 8.81881 3.15949 15.8013C3.15949 22.7838 8.81881 28.4432 15.8013 28.4432H20.936C21.8078 28.4432 22.5177 29.1491 22.5177 30.0248C22.5177 30.8967 21.8117 31.6065 20.936 31.6065H15.8013C7.07511 31.6027 0 24.5275 0 15.8013C0 7.07511 7.07511 0 15.8013 0H47.404C48.2758 0 48.9857 0.705967 48.9857 1.58168C48.9857 2.45353 48.2797 3.16335 47.404 3.16335H15.8013V3.15949Z",
    fill: "#101013"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48232 15.8012C9.48232 12.3099 12.3139 9.4822 15.8013 9.4822H28.4431V30.4182C28.4431 31.29 29.1491 31.9999 30.0248 31.9999C30.8967 31.9999 31.6065 31.2939 31.6065 30.4182V7.90052C31.6065 7.02867 30.9005 6.31885 30.0248 6.31885H15.8013C10.5663 6.31885 6.31897 10.5624 6.31897 15.8012C6.31897 21.04 10.5625 25.2835 15.8013 25.2835H20.936C21.8078 25.2835 22.5176 24.5776 22.5176 23.7018C22.5176 22.8261 21.8117 22.1202 20.936 22.1202H15.8013C12.31 22.1202 9.48232 19.2924 9.48232 15.8012Z",
    fill: "#101013"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3439 6.31885C37.2157 6.31885 37.9256 7.02482 37.9256 7.90052V30.4182C37.9256 31.29 37.2196 31.9999 36.3439 31.9999C35.472 31.9999 34.7622 31.2939 34.7622 30.4182V7.90052C34.7622 7.02867 35.472 6.31885 36.3439 6.31885Z",
    fill: "#101013"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtLogoSmall);
export default __webpack_public_path__ + "static/media/CT-logo-small.4bb1b02180bd5193145fb03540d215e9.svg";
export { ForwardRef as ReactComponent };